import { Box } from '@chakra-ui/react';

import { AppRouter } from '.';
import { startConsoleCapture } from '../utils/console-capture';

startConsoleCapture();

// The QA cockpit panel is a self-contained bundle served by its own dev server (`pnpm qa`), so it is
// loaded as a script tag rather than imported -- nothing from the package enters this app's module
// graph, its TS program, or any production bundle. Both flags are statically replaced at build time.
// Opt in with: VITE_QA_COCKPIT=1 pnpm dev
if (import.meta.env.DEV && import.meta.env.VITE_QA_COCKPIT === '1') {
	const script = document.createElement('script');
	script.type = 'module';
	script.src = `http://127.0.0.1:${import.meta.env.VITE_QA_PORT ?? '9320'}/overlay.js`;
	script.onerror = (): void => console.error('[qa-cockpit] panel not reachable — is `pnpm qa` running?');
	document.head.appendChild(script);
}

export const AppContainer = () => {
	// console.log('render:AppContainer');
	return (
		<Box width="100%" height="100%" minH="500px">
			<AppRouter />
		</Box>
	);
};
